import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String };

  connect() {
    this.timeout = setTimeout(() => {
      // Reload the chat frame to pick up suggestions saved to DB
      const frame = document.querySelector("turbo-frame#brand_chat");
      if (frame) frame.src = this.urlValue;
    }, 8000);
  }

  disconnect() {
    clearTimeout(this.timeout);
  }
}
